export const TURN_TIME_DEFINITIONS_BASE_URL = '/api/turnTimeDefinitions';

export const TURN_TIME_METRICS_URL = `${TURN_TIME_DEFINITIONS_BASE_URL}/metrics`;

export const DEFAULT_TRAILING_WINDOW_DAYS = 90;
